/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  titlePlaceholder: {
    id: "b2b.doplnkova-sluzba-detail.title-placeholder",
    defaultMessage: "Product"
  },
  messageEmpty: {
    id: "b2b.doplnkova-sluzba-detail.message-empty",
    defaultMessage: "Product not found"
  }
});

export default () => useMessages(MESSAGES);
